import { Col, Row } from 'react-dsgov';
import styles from './operacaoRepasseForm.module.scss';
import { BrCheckbox, BrCheckboxGroup, BrDivider, BrInput, BrSelect } from '@govbr-ds/react-components';
import { IRepasseParceiro } from '../../../../../../../../../interfaces/IBaseDeCalculo';
import {
  DocumentoVinculadoDetalhe,
  EDocumentoVinculado,
  ETipoVinculo,
  ETransportador,
} from '../../../../../../../../../enums/ERepasseParceiro';
import { useEffect, useState } from 'react';
import { validarDocumento } from '../../../../../../../../../utils/validarDocumento';
import { formatarCNPJOrCpf, unmaskSelectCpfCnpj } from '../../../../../../../../../utils/formatCNPJOrCPF';

interface ITitularArrendatarioOperacaoRepasseFormProps {
  setRepasseParceiro: React.Dispatch<React.SetStateAction<IRepasseParceiro | undefined>>;
  setIsFormularioValido: React.Dispatch<React.SetStateAction<boolean>>;
  setMensagemErro: React.Dispatch<React.SetStateAction<string[]>>;
  repasseParceiroEdicao?: IRepasseParceiro;
}

const OperacaoRepasseForm: React.FC<ITitularArrendatarioOperacaoRepasseFormProps> = ({
  setRepasseParceiro,
  setIsFormularioValido,
  setMensagemErro,
  repasseParceiroEdicao,
}) => {
  const [repasseParceiroState, setRepasseParceiroState] = useState<IRepasseParceiro>();

  useEffect(() => {
    if (repasseParceiroEdicao) {
      setRepasseParceiroState(repasseParceiroEdicao);
    }
  }, [repasseParceiroEdicao]);

  useEffect(() => {
    const validarFormulario = () => {
      const mensagensErros: string[] = [];
      if (!repasseParceiroState?.cpfCnpj) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo CPF/CNPJ não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (!repasseParceiroState?.nomeRazaoSocial) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Nome/Razão Social não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (!repasseParceiroState?.tipoVinculo) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Tipo Vínculo não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (!repasseParceiroState?.descricaoVinculo) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Descrição do Tipo de Vínculo não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (!repasseParceiroState?.endereco) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Endereço não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (!repasseParceiroState?.transportador) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Transportador não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (
        ETransportador[repasseParceiroState?.transportador as keyof typeof ETransportador] === ETransportador.TERCEIROS
      ) {
        if (!repasseParceiroState?.cpfCnpjTransportador) {
          setIsFormularioValido(false);
          mensagensErros.push('Campo CPF/CNPJ do Transportador não preenchido');
          setMensagemErro(mensagensErros);
          return;
        }
        if (!repasseParceiroState?.nomeRazaoSocialTransportador) {
          setIsFormularioValido(false);
          mensagensErros.push('Campo Nome/Razão Social do Transportador não preenchido');
          setMensagemErro(mensagensErros);
          return;
        }
        if (!repasseParceiroState?.enderecoTransportador) {
          setIsFormularioValido(false);
          mensagensErros.push('Campo Endereço do Transportador não preenchido');
          setMensagemErro(mensagensErros);
          return;
        }
        if (!validarDocumento(repasseParceiroState?.cpfCnpjTransportador)) {
          setIsFormularioValido(false);
          mensagensErros.push('Campo CPF/CNPJ do Transportador não é válido');
          setMensagemErro(mensagensErros);
          return;
        }
      }
      if (!repasseParceiroState?.localEntrega) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Local de Entrega do Repasse não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }

      if (!validarDocumento(repasseParceiroState?.cpfCnpj || '')) {
        setIsFormularioValido(false);
        mensagensErros.push('CPF/CNPJ inválido');
        setMensagemErro(mensagensErros);
        return;
      }
      if (
        repasseParceiroState?.documentosVinculados.includes(
          DocumentoVinculadoDetalhe[EDocumentoVinculado.OUTROS].nome
        ) &&
        !repasseParceiroState?.documentosVinculadosDescricao
      ) {
        setIsFormularioValido(false);
        mensagensErros.push('Campo Descrição de outros documentos vinculados não preenchido');
        setMensagemErro(mensagensErros);
        return;
      }

      setRepasseParceiro(repasseParceiroState);
      setIsFormularioValido(true);
    };

    validarFormulario();
  }, [repasseParceiroState]);

  useEffect(() => {
    setRepasseParceiroState({
      transportador: repasseParceiroState?.transportador || '',
      cpfCnpjTransportador: repasseParceiroState?.cpfCnpjTransportador || undefined,
      nomeRazaoSocialTransportador: repasseParceiroState?.nomeRazaoSocialTransportador || undefined,
      enderecoTransportador: repasseParceiroState?.enderecoTransportador || undefined,
      tipoVinculo: repasseParceiroState?.tipoVinculo || '',
      descricaoVinculo: repasseParceiroState?.descricaoVinculo || '',
      cpfCnpj: repasseParceiroState?.cpfCnpj || '',
      nomeRazaoSocial: repasseParceiroState?.nomeRazaoSocial || '',
      endereco: repasseParceiroState?.endereco || '',
      documentosVinculados: repasseParceiroState?.documentosVinculados || [],
      documentosVinculadosDescricao: repasseParceiroState?.documentosVinculadosDescricao || '',
      localEntrega: repasseParceiroState?.localEntrega || '',
      quantidadeTotal: repasseParceiroState?.quantidadeTotal || 0,
      valorTotal: repasseParceiroState?.valorTotal || 0,
      codigosNCM: repasseParceiroState?.codigosNCM || [],
    });
  }, []);

  const setTransportador = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        transportador: value,
      };
    });
  };

  const setTipoVinculo = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        tipoVinculo: value,
      };
    });
  };

  const setDescricaoVinculo = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        descricaoVinculo: value,
      };
    });
  };

  const setNomeRazaoSocial = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        nomeRazaoSocial: value,
      };
    });
  };

  const setCpfCnpj = (value: string) => {
    const cpfCnpjSemMascara = unmaskSelectCpfCnpj(value);
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        cpfCnpj: cpfCnpjSemMascara,
      };
    });
  };

  const setEndereco = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        endereco: value,
      };
    });
  };

  const setDocumentosVinculados = (checked: boolean, documento: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      if (checked && !prevState.documentosVinculados.includes(documento)) {
        return {
          ...prevState,
          documentosVinculados: [...prevState.documentosVinculados, documento],
        };
      }
      if (!checked && prevState.documentosVinculados.includes(documento)) {
        return {
          ...prevState,
          documentosVinculados: prevState.documentosVinculados.filter((doc) => doc !== documento),
        };
      }
    });
  };

  const setDescricaoOutros = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        documentosVinculadosDescricao: value,
      };
    });
  };

  const setEnderecoTransportador = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        enderecoTransportador: value,
      };
    });
  };

  const setNomeRazaoSocialTransportador = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        nomeRazaoSocialTransportador: value,
      };
    });
  };

  const setCpfCnpjTransportador = (value: string) => {
    const cpfCnpjSemMascara = unmaskSelectCpfCnpj(value);
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        cpfCnpjTransportador: cpfCnpjSemMascara,
      };
    });
  };

  const setLocalEntrega = (value: string) => {
    setRepasseParceiroState((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        localEntrega: value,
      };
    });
  };

  return (
    <div className={styles.container}>
      <Row className={styles.row}>
        <Col sm={4}>
          <BrSelect
            className={styles.select}
            label='Tipo de Vínculo'
            onChange={(value: string) => setTipoVinculo(value)}
            options={Object.keys(ETipoVinculo).map((key) => ({
              label: ETipoVinculo[key as keyof typeof ETipoVinculo],
              value: key,
            }))}
            value={repasseParceiroState?.tipoVinculo}
          />
        </Col>
        <Col sm={8}>
          <BrInput
            label='Descrição do Vínculo'
            value={repasseParceiroState?.descricaoVinculo}
            onChange={(e) => setDescricaoVinculo(e.target.value)}
          />
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col sm={4}>
          <BrInput
            label='CPF/CNPJ'
            value={formatarCNPJOrCpf(repasseParceiroState?.cpfCnpj || '')}
            onChange={(e) => setCpfCnpj(unmaskSelectCpfCnpj(e.target.value).slice(0, 14))}
          />
        </Col>
        <Col sm={8}>
          <BrInput
            label='Nome/Razão Social'
            value={repasseParceiroState?.nomeRazaoSocial}
            onChange={(e) => setNomeRazaoSocial(e.target.value)}
          />
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col>
          <BrInput
            label='Endereço'
            value={repasseParceiroState?.endereco}
            onChange={(e) => setEndereco(e.target.value)}
          />
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col className={styles.column}>
          <span className={styles.label}>Documentos Vinculados à Operação</span>
          <div className={styles.checkboxGroup}>
            <BrCheckboxGroup inline inlineMargin={4}>
              {Object.keys(EDocumentoVinculado).map((key) => (
                <BrCheckbox
                  key={key}
                  label={DocumentoVinculadoDetalhe[EDocumentoVinculado[key as keyof typeof EDocumentoVinculado]]?.label}
                  checked={repasseParceiroState?.documentosVinculados.includes(
                    DocumentoVinculadoDetalhe[EDocumentoVinculado[key as keyof typeof EDocumentoVinculado]]?.nome
                  )}
                  value={DocumentoVinculadoDetalhe[EDocumentoVinculado[key as keyof typeof EDocumentoVinculado]]?.nome}
                  onChange={(e) => setDocumentosVinculados(e.target.checked, e.target.value)}
                />
              ))}
            </BrCheckboxGroup>
            <BrInput
              density='small'
              className={styles.input}
              value={
                repasseParceiroState?.documentosVinculadosDescricao
                  ? repasseParceiroState.documentosVinculadosDescricao
                  : ''
              }
              onChange={(e) => setDescricaoOutros(e.target.value)}
              placeholder='...Descrição'
              disabled={
                !repasseParceiroState?.documentosVinculados.includes(
                  DocumentoVinculadoDetalhe[EDocumentoVinculado.OUTROS].nome
                )
              }
            />
          </div>
        </Col>
      </Row>
      <div className={styles.dividerContainer}>
        <BrDivider />
      </div>
      <Row className={styles.row}>
        <Col sm={4}>
          <BrSelect
            className={styles.select}
            label='Transportador'
            onChange={(value: string) => setTransportador(value)}
            options={Object.keys(ETransportador).map((key) => ({
              label: ETransportador[key as keyof typeof ETransportador],
              value: key,
            }))}
            value={repasseParceiroState?.transportador}
          />
        </Col>
      </Row>
      {repasseParceiroState?.transportador &&
        ETransportador[repasseParceiroState.transportador as keyof typeof ETransportador] ===
          ETransportador.TERCEIROS && (
          <>
            <Row className={styles.row}>
              <Col sm={4}>
                <BrInput
                  label='CPF/CNPJ'
                  value={formatarCNPJOrCpf(repasseParceiroState?.cpfCnpjTransportador || '')}
                  onChange={(e) => setCpfCnpjTransportador(unmaskSelectCpfCnpj(e.target.value).slice(0, 14))}
                />
              </Col>
              <Col sm={8}>
                <BrInput
                  label='Nome/Razão Social'
                  value={repasseParceiroState?.nomeRazaoSocialTransportador}
                  onChange={(e) => setNomeRazaoSocialTransportador(e.target.value)}
                />
              </Col>
            </Row>
            <Row className={styles.row}>
              <Col>
                <BrInput
                  label='Endereço'
                  value={repasseParceiroState?.enderecoTransportador}
                  onChange={(e) => setEnderecoTransportador(e.target.value)}
                />
              </Col>
            </Row>
          </>
        )}

      <div className={styles.dividerContainer}>
        <BrDivider />
      </div>
      <Row className={styles.row}>
        <Col>
          <BrInput
            label='Local de Entrega do Repasse'
            value={repasseParceiroState?.localEntrega}
            onChange={(e) => setLocalEntrega(e.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default OperacaoRepasseForm;
